import { COLOR_PRIMARY } from "../../../../Constants/Styles"
//API
//componentes
//material ui
import Box from "@mui/material/Box"
import TableCell from "@mui/material/TableCell"
import TableRow from "@mui/material/TableRow"
// import { UseColaborador } from "./UsoMovimientos"

export const FormTableItem = ({ colaborador, tableData }) => {
	return (
		<TableRow>
			{tableData.map((campo) => {
				if (campo.id === "foto")
					return (
						<TableCell component="th" scope="row">
							<Box
								component="img"
								sx={{ height: 75 }}
								alt="No se cuenta con fotografía"
								src={colaborador?.photo}
								onError={(e) => {
									e.target.onerror = null
									e.target.src =
										"https://imagenespublicas.s3.us-east-2.amazonaws.com/usuario.webp"
								}}
							/>
						</TableCell>
					)
				return (
					<TableCell sx={{ fontSize: 16, color: COLOR_PRIMARY, fontWeight: "bold" }}>
						{colaborador[campo.id]}
					</TableCell>
				)
			})}
		</TableRow>
	)
}
